import { render, staticRenderFns } from "./CurriculumList.vue?vue&type=template&id=b5476a2a&scoped=true"
import script from "./CurriculumList.vue?vue&type=script&setup=true&lang=ts"
export * from "./CurriculumList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CurriculumList.vue?vue&type=style&index=0&id=b5476a2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5476a2a",
  null
  
)

export default component.exports